import { render, staticRenderFns } from "./Balloon.vue?vue&type=template&id=47fb89b2&"
import script from "./Balloon.vue?vue&type=script&lang=js&"
export * from "./Balloon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports